import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EventFormComponent } from '../../hero-report/event-form/event-form.component';


@Component({
  selector: 'app-hero-report-step2',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, EventFormComponent],
  templateUrl: './hero-report-step2.component.html',
  styleUrls: ['./hero-report-step2.component.scss'],
})
export class HeroReportStep2Component {
  @Input() formGroup!: FormGroup;

  yesNoUnknownOptions = [
    { label: $localize`:@@common.yes:Yes`, value: true },
    { label: $localize`:@@common.no:No`, value: false },
    { label: $localize`:@@common.unknown:Unknown`, value: null },
  ];

  yesNoOptions = [
    { label: $localize`:@@common.yes:Yes`, value: true },
    { label: $localize`:@@common.no:No`, value: false },
  ];
}
